module.exports = __webpack_public_path__ + "static/img/default@2x.e40632a0.png";